import errorList from '#helpers/logging/errorList.js'
import Logger from '#helpers/logging/Logger.js'

/**
 * @param {object|ArrayBuffer} [data] - Data with errors
 * @param {string} [data.error] - An error holder
 * @param {string} [data.error.message] - A message for the error
 * @param {Array} [data.errors] - A list of errors
 * @param {string} [data.message] - A single message
 * @returns {HTMLUListElement} - An HTML list
 */
export default function errorBag(data) {
	let internalData = data

	Logger.debug(internalData)

	// Sometimes the returned data is NOT json
	// For example when asking for a file with getFile, which uses { responseType: 'arraybuffer' }
	// to force an ArrayBuffer because that is the way to get a file
	// But the errors are still in JSON
	if (internalData instanceof ArrayBuffer) {
		internalData = JSON.parse(new TextDecoder('utf-8').decode(new Uint8Array(internalData)))
	}

	const errorMessages = []

	if (typeof internalData === 'string') {
		errorMessages.push(internalData)
	}

	if (typeof internalData?.error === 'string' && internalData?.error) {
		errorMessages.push(internalData.error)
	}

	if (internalData?.error?.message) {
		errorMessages.push(internalData.error.message)
	}

	if (internalData?.message) {
		errorMessages.push(internalData.message)
	}

	if (internalData?.errors) {
		Object.values(internalData.errors).forEach(error => {
			if (typeof error === 'string') {
				errorMessages.push(error)
			} else {
				error.map(subError => errorMessages.push(subError))
			}
		})
	}

	return errorList(errorMessages)
}
